import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=19c65629&"
import script from "./ReportTable.js?vue&type=script&lang=js&"
export * from "./ReportTable.js?vue&type=script&lang=js&"
import style0 from "./ReportTable.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports